<template lang="pug">
	.network-show--episodes-list.flex-col.space
		ListView.full-width.no-padding(
			ref="list",
			initialView="cards",
			:getTotal="(r) => r.TotalNumberOfRecords",
			:getItems="(r) => r.Results",
			:getData="(pIdx, limit, opts) => $Data.getNetworkShowEpisodes(pIdx, limit, opts, networkShowId)",
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="50",
			:showColumnHeaders="false",
			:searchVisible="true",
			:topPagerVisible="false"
		)
			template(v-slot:left-actions="{ data }")
				.flex-row.space-medium.align-center
					.font-big.upper.grey {{$tCaption('Episodes')}}
					slot
			template(v-slot:card="{ data }")
				.flex-col.episode-item.clickable.hoverable(@click="openCreative(data)")
					.flex-row.space.align-center
						.upper.font-small(v-if="data.AirDateTime") {{getEpisodeDate(data).format('LLLL')}}
						.publish-sate.flex-row.space-small.align-center(:class="{ published: data.IsPublished }") 
							fas(v-if="data.IsPublished", icon="check")
							span {{data.IsPublished ? $tCaption('Published') : $tCaption('Not published')}}
					.flex-row.space.align-center
						fas(icon="diamond")
						.upper.font-lg {{data.Name || $tCaption('Episode')}}
						.grey(v-if="data.Subname") ({{data.Subname}})
						DxButton(icon="close", stylingMode="text", @click="e => { e.event.stopPropagation(); deleteEpisode(data.Oid); }", :hint="$tCaption('Delete', '@actions')")
					.grey(v-if="data.Description") {{data.Description}}
					.flex-row.space.align-center
						DxButton(:text="$tCaption('Edit episode in network studio')", icon="fas fa-arrow-right", @click="e => { e.event.stopPropagation(); openCreative(data) }", stylingMode="text")
		Loader(v-if="isLoading", text="", :fullscreen="true")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import Popup from 'app-core/Popup.vue';
	import ListView from 'app-core/ListView.vue';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'networkShow.EpisodesList',
		name: 'network-show--episodes-list',
		props: ['networkShowId'],
		components: {
			DxButton, Popup, ListView, Loader
		},
		data() {
			return {
				editingPopup: {
					visible: false,
					episode: null,
					loading: false
				},
				isLoading: false
			};
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowEpisodes = this;
			this.$eventsBus.$on('new-episode-created', this.onNewEpisodeCreated);
		},
		destroyed() {
			this.$eventsBus.$off('new-episode-created', this.onNewEpisodeCreated);
		},
		methods: {
			onNewEpisodeCreated() {
				if (this.$refs.list)
					this.$refs.list.reload();
			},
			openCreative(episode) {
				this.$router.push({ name: 'creative-detail', params: { 
					creativeId: episode.Creative?.Oid,
					opts: {
						networkStudio: true,
						backLink: {
							name: episode.Name || this.$tCaption('Episode'),
							route: { path: `/network-studio/show/${this.networkShowId}`, query: { tab: 'episodes' } }
						},
						networkShowId: this.networkShowId
					}
				}});
			},
			deleteEpisode(id) {
				this.$confirm().then(() => {
					this.isLoading++;
					this.$Data.deleteNetworkShowEpisode(id).then(() => {
						this.editingPopup.visible = false;
						if (this.$refs.list)
							this.$refs.list.reload();
					}).finally(() => this.isLoading--);
				});
			},
			getEpisodeDate(clock) {
				const date = this.$moment(clock.AirDateTime).startOf('day');
				date.set('hours', clock.Hour)
				return date;
			},
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--episodes-list {
		.card {
			flex: auto !important;
			width: 100%;
			margin: 0px;
			padding: 10px 0px;
			border-bottom: 1px solid #eaeaea;
		}

		.publish-sate {
			font-size: 10px;
			padding: 2px 4px;
			border-radius: 4px;
			background: rgba(0,0,0,0.05);
			color: #333;

			&.published {
				background: $base-accent;
				color: $base-bg;
			}
		}
	}
</style>
